import { PricingPageAnchor } from "@frec-js/common-client";
import { FC } from "react";

import { TextLink } from "../../components/Link";
import { RateTable } from "../../components/RateTable";

export const PricingBorrowRates: FC<{ id?: string }> = ({
  id = PricingPageAnchor.BorrowRates,
}) => {
  return (
    <section
      id={id}
      className="bg-frecBeige grid grid-cols-[auto_minmax(0,86rem)_auto] grid-rows-[96px_auto_auto_96px]"
    >
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v flex flex-col items-center gap-3 px-6 lg:mx-12 lg:border-x lg:px-16">
        <h2 className="text-center">Borrow at one of the lowest rates</h2>
        <p className="lg:text-20 max-w-[800px] px-6 pt-6 pb-12 text-center">
          Borrow up to 70%<sup>4</sup> of your direct index portfolio through a
          portfolio line of credit. Our rate is always the{" "}
          <TextLink
            href="https://www.newyorkfed.org/markets/reference-rates/effr"
            target="_blank"
          >
            Effective Federal Funds Rate
          </TextLink>{" "}
          + 1%, lower than many of our competitor’s listed rates.
        </p>
      </div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">
        <RateTable />
      </div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className=""></div>
      <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="dotted-h col-span-3 border-b">{/* empty */}</div>
    </section>
  );
};
